import { render } from "./WidgetAttrs.vue?vue&type=template&id=4a25f85e&scoped=true"
import script from "./WidgetAttrs.vue?vue&type=script&lang=js"
export * from "./WidgetAttrs.vue?vue&type=script&lang=js"

import "./WidgetAttrs.vue?vue&type=style&index=0&id=4a25f85e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a25f85e"],['__file',"src/components/widgets/WidgetAttrs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a25f85e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a25f85e', __exports__)) {
    api.reload('4a25f85e', __exports__)
  }
  
  module.hot.accept("./WidgetAttrs.vue?vue&type=template&id=4a25f85e&scoped=true", () => {
    api.rerender('4a25f85e', render)
  })

}


export default __exports__